import { render } from "./LoadingDataFetch.vue?vue&type=template&id=2c3b68a4&scoped=true"
import script from "./LoadingDataFetch.vue?vue&type=script&lang=js"
export * from "./LoadingDataFetch.vue?vue&type=script&lang=js"

import "./LoadingDataFetch.vue?vue&type=style&index=0&id=2c3b68a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c3b68a4"]])

export default __exports__